import { render, staticRenderFns } from "./harvestDetail.vue?vue&type=template&id=34f6abc1"
import script from "./harvestDetail.vue?vue&type=script&lang=ts"
export * from "./harvestDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports